export default __webpack_public_path__ + "static/media/Kefmeh.6f2b1c21.jpg";